import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import TextInput from "../TextField/TextInput";
import "./AutoComplete.css";

function AutoComplete({
    name,
    ref,
    onChange,
    items,
    getItemValue,
    value,
    setValue,
    onSelect,
    shouldItemRender,
    renderItem,
    apiCall,
    paramsApi,
    getImageFromItem,
    getNameFromItem,
    className,
    placeholder,
    closeOnBlur,
}) {
    // shouldItemRender(item, value)
    const [show, setShow] = useState(apiCall == null ? false : true);
    const [valueContent, setValueContent] = useState(value != null ? value : "");
    const [itemsContent, setItemsContent] = useState(items != null ? items : []);
    const [dropdownPos, setDropdownPos] = useState(null);
    const containerRef = useRef();

    const computeDropdownPos = () => {
        if (!containerRef.current) return null;
        const rect = containerRef.current.getBoundingClientRect();
        const estimatedHeight = 200;
        const flipUp = window.innerHeight - rect.bottom < estimatedHeight && rect.top > estimatedHeight;
        return {
            position: 'fixed',
            top: flipUp ? 'auto' : rect.bottom,
            bottom: flipUp ? window.innerHeight - rect.top : 'auto',
            left: rect.left,
            width: rect.width,
            zIndex: 99999,
        };
    };

    const getFilteredItems = () => {
        const filteredItems = itemsContent.filter((item) => shouldItemRender(getNameFromItem(item), valueContent));
        return filteredItems;
    };

    const loadAutocompleteArray = (e) => {
        let func = apiCall ? loadItems : searchItemsInArray;
        func(e.target.value);
        setValueContent(e.target.value);
        const shouldShow = e.target.value.length >= 1;
        setShow(shouldShow);
        if (shouldShow) setDropdownPos(computeDropdownPos());
        getItemValue(name, e.target.value);
    };
    const searchItemsInArray = (val, data = null) => {
        if (data == null) {
            data = itemsContent;
        }
        val = val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regexp = new RegExp(`^${val}$`, "i");
        const item = itemsContent.filter((row) => regexp.test(row.name)).pop();
        if (item) {
            selectItem(item);
        }
    };
    const loadItems = async (val) => {
        if (apiCall == null) return;
        let parameters = val;

        if (paramsApi != null) {
            Object.keys(paramsApi).forEach((key) => {
                parameters += "&" + key + "=" + paramsApi[key];
            });
        }

        let [response, error] = await apiCall(parameters);
        if (error !== null) {
            console.log(error);
            return;
        }

        setItemsContent(response);
        searchItemsInArray(val, response);
        /*
        const regexp = new RegExp(`^${val}$`, 'i');
        const item = response.filter(row => regexp.test(row.name)).pop();
        if(item) {
            selectItem(item);
        }
            */
    };

    const selectItem = (item) => {
        getItemValue(name, item);
        setValueContent(getNameFromItem(item));
        setShow(false);
    };

    useEffect(() => {
        setValueContent(value ?? "");
    }, [value]);
    return (
        <div style={{ position: "relative" }} ref={containerRef}>
            <TextInput
                value={valueContent}
                name={name}
                ref={ref}
                onChange={(e) => {
                    loadAutocompleteArray(e);
                }}
                onBlur={closeOnBlur ? () => setShow(false) : undefined}
                className={className ? className : "input"}
                placeholder={placeholder}
            />
            {show && createPortal(
                <div className="autocomplete-items" style={dropdownPos}>
                    {getFilteredItems().map((item, index) => {
                        const nameItem = getNameFromItem(item);
                        const image = getImageFromItem ? getImageFromItem(item) : "";

                        return (
                            <div
                                key={index}
                                onMouseDown={() => {
                                    onSelect(selectItem(item));
                                }}>
                                {renderItem(nameItem, valueContent, image)}
                            </div>
                        );
                    })}
                </div>,
                document.body
            )}
        </div>
    );
}

AutoComplete.defaultProps = {
    items: [],
    value: "",
    getNameFromItem: (item) => item.name,
    onSelect: (val) => val,
    onChange: (e) => e,
    getItemValue: (item) => item,
    shouldItemRender: (nameItem, value) => (nameItem.toLowerCase().indexOf(value.toLowerCase()) > -1 ? true : false),
    renderItem: (nameItem, value, image) => {
        const safeValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // evite les crahs si [toto : crochet pas fini
        const regex = new RegExp(`(${safeValue})`, "ig");
        const parts = nameItem.split(regex);

        return (
            <>
                {image ? <img src={image} alt="item" /> : null}
                <span>
                    {parts.map((part, i) =>
                        part.toLowerCase() === value.toLowerCase() ? (
                            <strong key={i}>{part}</strong>
                        ) : (
                            <span key={i}>{part}</span>
                        )
                    )}
                </span>
            </>
        );
    },
};

export default AutoComplete;
